import React, {
	createContext,
	useContext,
	useReducer,
	type Dispatch,
	type SetStateAction,
} from 'react';

const noop = () => {
	/* empty */
};
const CustomThemeDataContext = createContext<CustomThemeData>({});
const SetCustomThemeDataContext =
	createContext<Dispatch<Partial<SetStateAction<CustomThemeData>>>>(noop);

export const useCustomThemeData = () => useContext(CustomThemeDataContext);
export const useSetCustomThemeData = () => useContext(SetCustomThemeDataContext);

/**
 *
 * Collects custom theme data and provides it via context to be used by CustomThemeAnalytics.
 *
 */
export function CustomThemeDataProvider({
	children,
	value = {},
}: {
	children: React.ReactNode;
	value?: CustomThemeData;
}) {
	const [state, dispatch] = useReducer(reducer, value);

	return (
		<CustomThemeDataContext.Provider value={state}>
			<SetCustomThemeDataContext.Provider value={dispatch}>
				{children}
			</SetCustomThemeDataContext.Provider>
		</CustomThemeDataContext.Provider>
	);
}

const reducer = (state: CustomThemeData, action: Partial<CustomThemeData>): CustomThemeData => {
	return {
		...state,
		...action,
	};
};

type CustomThemeData = {
	cloudId?: string;
	customLogoSize?: {
		width?: number;
		height?: number;
	};
	customSiteTitleLength?: number;
	hasCustomBGColor?: boolean;
	hasCustomHighlightColor?: boolean;
	hasCustomLogo?: boolean;
	hasCustomSiteTitle?: boolean;
};
